export const APARTMENT_LIST = {
  ROOT: '/apartmentList',
};
